export default __webpack_public_path__ + "static/media/snow.6716ed80.png";